module.exports = __webpack_public_path__ + "img/flag-green.af5bc600.svg";